import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    { attrs: { fluid: "" } },
    [
      _c(
        VRow,
        { staticClass: "mb-2", attrs: { align: "center" } },
        [
          _c(VCol, { attrs: { cols: "12", md: "3" } }, [
            _c("h2", { staticClass: "text-h5" }, [_vm._v("Gate report")]),
            _c("div", { staticClass: "caption grey--text" }, [
              _vm._v("Vehicle movements recorded at the factory gate"),
            ]),
          ]),
          _c(
            VCol,
            { attrs: { cols: "6", md: "2" } },
            [
              _c(VTextField, {
                attrs: {
                  label: "From",
                  type: "date",
                  dense: "",
                  outlined: "",
                  "hide-details": "",
                },
                model: {
                  value: _vm.from,
                  callback: function ($$v) {
                    _vm.from = $$v
                  },
                  expression: "from",
                },
              }),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "6", md: "2" } },
            [
              _c(VTextField, {
                attrs: {
                  label: "To",
                  type: "date",
                  dense: "",
                  outlined: "",
                  "hide-details": "",
                },
                model: {
                  value: _vm.to,
                  callback: function ($$v) {
                    _vm.to = $$v
                  },
                  expression: "to",
                },
              }),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "12", md: "2" } },
            [
              _c(VTextField, {
                attrs: {
                  label: "Search plate, company, driver",
                  dense: "",
                  outlined: "",
                  "hide-details": "",
                  clearable: "",
                  "prepend-inner-icon": "mdi-magnify",
                },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "12", md: "3" } },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary", loading: _vm.loading },
                  on: { click: _vm.load },
                },
                [
                  _c(VIcon, { attrs: { left: "" } }, [
                    _vm._v("mdi-magnify"),
                  ]),
                  _vm._v("Show "),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-2",
                  attrs: { text: "" },
                  on: { click: _vm.setToday },
                },
                [_vm._v("Today")]
              ),
              _c(
                VBtn,
                {
                  attrs: { text: "" },
                  on: {
                    click: function ($event) {
                      return _vm.setDays(7)
                    },
                  },
                },
                [_vm._v("7 days")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.error
        ? _c(VAlert, { attrs: { type: "error", dense: "", text: "" } }, [
            _vm._v(_vm._s(_vm.error)),
          ])
        : _vm._e(),
      _vm.summary
        ? _c(
            VRow,
            { staticClass: "mb-2" },
            _vm._l(_vm.tiles, function (t) {
              return _c(
                VCol,
                { key: t.key, attrs: { cols: "6", md: "2" } },
                [
                  _c(
                    VCard,
                    {
                      staticClass: "tile",
                      class: { on: _vm.filter === t.key },
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          return _vm.pickTile(t)
                        },
                      },
                    },
                    [
                      _c(VCardText, { staticClass: "py-3" }, [
                        _c("div", { staticClass: "text-h4", class: t.colour }, [
                          _vm._v(_vm._s(t.value)),
                        ]),
                        _c("div", { staticClass: "caption grey--text" }, [
                          _vm._v(_vm._s(t.label)),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _vm.filter
        ? _c(
            VRow,
            { staticClass: "mb-2", attrs: { "no-gutters": "" } },
            [
              _c(
                VCol,
                [
                  _c(
                    VChip,
                    {
                      attrs: { close: "", color: "primary", outlined: "" },
                      on: {
                        "click:close": function ($event) {
                          _vm.filter = ""
                        },
                      },
                    },
                    [
                      _vm._v(
                        " Showing " +
                          _vm._s(_vm.activeTileLabel.toLowerCase()) +
                          " (" +
                          _vm._s(_vm.shownVisits.length) +
                          ") "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        VCard,
        { attrs: { outlined: "" } },
        [
          _c(VDataTable, {
            staticClass: "clickable-rows",
            attrs: {
              headers: _vm.headers,
              items: _vm.shownVisits,
              search: _vm.search,
              loading: _vm.loading,
              "items-per-page": 25,
              dense: "",
              "no-data-text": _vm.filter
                ? "Nothing matches this tile"
                : "No vehicles in this period",
            },
            on: { "click:row": _vm.open },
            scopedSlots: _vm._u([
              {
                key: "item.visitType",
                fn: function ({ item }) {
                  return [
                    item.visitType
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.typeLabel(item.visitType))),
                        ])
                      : _c("span", { staticClass: "grey--text" }, [
                          _vm._v("—"),
                        ]),
                  ]
                },
              },
              {
                key: "item.companyName",
                fn: function ({ item }) {
                  return [
                    item.companyName
                      ? _c(
                          "span",
                          [
                            _vm._v(" " + _vm._s(item.companyName) + " "),
                            item.companyFromRegistry
                              ? _c(
                                  VIcon,
                                  {
                                    attrs: {
                                      "x-small": "",
                                      color: "grey",
                                      title:
                                        "from the vehicle registry — not confirmed",
                                    },
                                  },
                                  [_vm._v("mdi-help-circle-outline")]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _c("span", { staticClass: "grey--text" }, [
                          _vm._v("—"),
                        ]),
                  ]
                },
              },
              {
                key: "item.driverName",
                fn: function ({ item }) {
                  return [
                    item.driverName
                      ? _c("span", [_vm._v(_vm._s(item.driverName))])
                      : _c("span", { staticClass: "grey--text" }, [
                          _vm._v("—"),
                        ]),
                  ]
                },
              },
              {
                key: "item.entryTime",
                fn: function ({ item }) {
                  return [_vm._v(_vm._s(_vm.fmt(item.entryTime)))]
                },
              },
              {
                key: "item.exitTime",
                fn: function ({ item }) {
                  return [
                    item.exitTime
                      ? _c("span", [_vm._v(_vm._s(_vm.fmt(item.exitTime)))])
                      : _c(
                          VChip,
                          { attrs: { "x-small": "", color: "blue lighten-4" } },
                          [_vm._v("still on site")]
                        ),
                  ]
                },
              },
              {
                key: "item.registered",
                fn: function ({ item }) {
                  return [
                    _c(
                      VChip,
                      {
                        attrs: {
                          "x-small": "",
                          color: item.registered
                            ? "green lighten-4"
                            : "red lighten-4",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              item.registered ? "registered" : "not registered"
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "item.onSite",
                fn: function ({ item }) {
                  return [_vm._v(_vm._s(_vm.duration(item)))]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        VDialog,
        {
          attrs: { "max-width": "900", scrollable: "" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _vm.selected
            ? _c(
                VCard,
                [
                  _c(
                    VCardTitle,
                    [
                      _c("span", { staticClass: "text-h6" }, [
                        _vm._v(_vm._s(_vm.selected.plateNumber)),
                      ]),
                      _c(
                        VChip,
                        {
                          staticClass: "ml-3",
                          attrs: {
                            "x-small": "",
                            color: _vm.selected.registered
                              ? "green lighten-4"
                              : "red lighten-4",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.selected.registered
                                  ? "registered"
                                  : "not registered"
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(VSpacer),
                      _c(
                        VBtn,
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              _vm.dialog = false
                            },
                          },
                        },
                        [_c(VIcon, [_vm._v("mdi-close")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCardText,
                    [
                      _c(
                        VRow,
                        { attrs: { dense: "" } },
                        _vm._l(_vm.detailFields, function (f) {
                          return _c(
                            VCol,
                            { key: f.label, attrs: { cols: "6", md: "4" } },
                            [
                              _c("div", { staticClass: "caption grey--text" }, [
                                _vm._v(_vm._s(f.label)),
                              ]),
                              _c("div", [_vm._v(_vm._s(f.value || "—"))]),
                            ]
                          )
                        }),
                        1
                      ),
                      _c(VDivider, { staticClass: "my-4" }),
                      _c("div", { staticClass: "subtitle-2 mb-2" }, [
                        _vm._v(" Photos"),
                        _vm.photos.length
                          ? _c("span", { staticClass: "grey--text" }, [
                              _vm._v(" (" + _vm._s(_vm.photos.length) + ")"),
                            ])
                          : _vm._e(),
                      ]),
                      _vm.detailLoading
                        ? _c(VProgressLinear, {
                            attrs: { indeterminate: "" },
                          })
                        : !_vm.photos.length
                        ? _c("div", { staticClass: "grey--text" }, [
                            _vm._v("No photos on this visit"),
                          ])
                        : _c(
                            VRow,
                            { attrs: { dense: "" } },
                            _vm._l(_vm.photos, function (p) {
                              return _c(
                                VCol,
                                {
                                  key: p.fileId,
                                  attrs: { cols: "6", md: "4" },
                                },
                                [
                                  _c(
                                    VCard,
                                    { attrs: { outlined: "" } },
                                    [
                                      _vm.photoUrls[p.fileId]
                                        ? _c(VImg, {
                                            attrs: {
                                              src: _vm.photoUrls[p.fileId],
                                              "aspect-ratio": "1.4",
                                            },
                                          })
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "pa-6 text-center grey--text",
                                            },
                                            [_vm._v("…")]
                                          ),
                                      _c(
                                        VCardSubtitle,
                                        { staticClass: "py-1 caption" },
                                        [_vm._v(_vm._s(_vm.slotLabel(p.slot)))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }